import { useNamespaceContainer } from "@pharaday/namespace";

import { NavigationRepository } from "../core/application/store/navigation.repository";

const useNavigationApi = () => {
  const container = useNamespaceContainer();

  return {
    api: {
      navigation: container.get<NavigationRepository>(NavigationRepository),
    },
  };
};

export { useNavigationApi };
